/* global Blob */
import React from 'react';
import { connect } from 'react-redux';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Button } from 'react-toolbox/lib/button';
import { debounce, isEqual } from 'lodash';

import { productionQueueDistributor } from '~/actions/boxStats';
import Spinner from '~/components/Spinner';

import style from './widget.scss';

class ProductionQueueDistributor extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      products: [],
      loading: false,
      expanded: !props.indata.expandable
    };
  }

  componentDidMount() {
    this.fetchProducts();
    this.fetchProducts = debounce(this.fetchProducts.bind(this), 1000);
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.orders, nextProps.orders)) {
      this.fetchProducts();
    }
  }

  getProducts() {
    return this.state.products;
  }

  fetchProducts() {
    this.setState({ loading: true });
    productionQueueDistributor(this.context.apiClient)
      .then(r => this.setState({ products: r.data, loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  export(data) {
    const workbook = {
      SheetNames: ['Data'],
      Sheets: { Data: XLSX.utils.json_to_sheet(data) }
    };
    const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' };
    const wbout = XLSX.write(workbook, wopts);
    saveAs(
      new Blob([wbout], { type: 'application/octet-stream' }),
      'export.xlsx'
    );
  }

  render() {
    const products = this.getProducts();
    return (
      <div className={this.props.className}>
        {this.state.loading && <Spinner />}
        {!this.state.loading && (
          <div
            className={[
              style.productionSection,
              this.state.expanded ? style.expanded : style.expandable
            ].join(' ')}
          >
            <div className={style.header}>
              <h5 className={style.productionTitle}>
                {this.props.indata.title || <span>&nbsp;</span>}
              </h5>
              <Button
                onClick={() => this.export(products)}
                label="Export .xlsx"
                icon="file_download"
                accent
                raised
                className={style.productionExport}
              />
              <Button
                onClick={() => this.setState({ expanded: true })}
                label="Show all"
                icon="keyboard_arrow_down"
                accent
                raised
                className={style.expand}
              />
            </div>
            <table className={style.products}>
              <thead>
                <tr>
                  <td>Invoice ID</td>
                  <td>Lot code</td>
                  <td>Product</td>
                  <td className={style.count}>Amount</td>
                </tr>
              </thead>
              <tbody>
                {products.map(p => (
                  <tr
                    key={`${p.sku}__${p.orderId}`}
                    className={style.productionRow}
                  >
                    <td className={style.invoiceId}>{p.invoiceId}</td>
                    <td>{p.lot}</td>
                    <td
                      className={style.title}
                      dangerouslySetInnerHTML={{ __html: p.title }}
                    />
                    <td className={style.count}>{p.count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!this.state.loading &&
              products.length === 0 && (
                <div>No pending {this.props.indata.orderStatus} products</div>
              )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const orders = state.getIn(
    ['orders', 'tabData', 'Distributor', 'orders'],
    false
  );
  return {
    orders: orders && orders.toJS()
  };
};

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(
  ProductionQueueDistributor
);



// WEBPACK FOOTER //
// ./app/widgets/ProductionQueueDistributor/widget.js